module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/menu-icon-condition-ed5c4b065998965f9994ee5081b899e8.svg";